'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { ProductInfoComponentProps } from './product-info.component';
import dynamic from 'next/dynamic';

const DynamicProductInfoComponent: ComponentType<ProductInfoComponentProps> = dynamic(
  () => import('./product-info.component')
);

export default DynamicProductInfoComponent;

export function calculateProductInfoPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 1126 },
    { sinceWidth: 425, height: 1139 },
    { sinceWidth: 520, height: 1196 },
    { sinceWidth: 620, height: 1277 },
    { sinceWidth: 720, height: 1377 },
    { sinceWidth: 768, height: 936 },
    { sinceWidth: 1024, height: 866 },
    { sinceWidth: 1442, height: 750 }
  ];

  return {
    heightSinceWidth
  };
}
